import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // Load translation using http -> see /public/locales
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  .init({
    debug: false, // Enable if need detailed information whats happening with localization
    fallbackLng: 'fi',
    defaultNS: 'common',
    ns: [
      'common',
      'sidenav',
      'dashboard',
      'accommodationAutoCompleteSearchBar',
      'basicSearchFilters',
      'searchBookableAccommodations',
      'bookings',
      'containerDetails',
      'travelAgencyBookingModal',
      'bookingDetails',
    ],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    react: {
      useSuspense: true,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
